import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf3fbc20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
    /*#__PURE__*/_createTextVNode("ข้อมูลหน่วยงานอื่นๆ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "จัดการข้อมูลหน่วยงานอื่นๆ ที่ต้องการแสดงบนหน้าเว็บไซต์")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-asterisk me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SupportTableComponent = _resolveComponent("SupportTableComponent")!
  const _component_DownloadTableComponent = _resolveComponent("DownloadTableComponent")!
  const _component_LawTableComponent = _resolveComponent("LawTableComponent")!
  const _component_SupportFormComponent = _resolveComponent("SupportFormComponent")!
  const _component_DownloadFormComponent = _resolveComponent("DownloadFormComponent")!
  const _component_LawFormComponent = _resolveComponent("LawFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-primary mb-3",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createSupportClick && _ctx.createSupportClick(...args)))
          }, [
            _hoisted_5,
            _createTextVNode("เพิ่มข้อมูลในการสนับสนุนการกำกับและติดตามการปฏิบัติราชการในภูมิภาค ")
          ]),
          _createVNode(_component_SupportTableComponent, { onEdit: _ctx.editSupportClick }, null, 8, ["onEdit"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-primary mb-3",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createDownloadClick && _ctx.createDownloadClick(...args)))
          }, [
            _hoisted_7,
            _createTextVNode("เพิ่มข้อมูลดาวน์โหลดเอกสาร ")
          ]),
          _createVNode(_component_DownloadTableComponent, { onEdit: _ctx.editDownloadClick }, null, 8, ["onEdit"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn btn-primary mb-3",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createLawClick && _ctx.createLawClick(...args)))
          }, [
            _hoisted_8,
            _createTextVNode("เพิ่มข้อมูลกฎหมายและระเบียบที่เกี่ยวข้อง ")
          ]),
          _createVNode(_component_LawTableComponent, { onEdit: _ctx.editLawClick }, null, 8, ["onEdit"])
        ])
      ])
    ]),
    _createVNode(_component_SupportFormComponent, {
      ref: "supportForm",
      "support-id": _ctx.selectedSupportId
    }, null, 8, ["support-id"]),
    _createVNode(_component_DownloadFormComponent, {
      ref: "downloadForm",
      "download-id": _ctx.selectedDownloadId
    }, null, 8, ["download-id"]),
    _createVNode(_component_LawFormComponent, {
      ref: "lawForm",
      "law-id": _ctx.selectedLawId
    }, null, 8, ["law-id"])
  ], 64))
}